export const jStorageKeys = {
    AUTH_TOKEN: 'HB_AUTH_TOKEN',
    TRUSTED_DEVICE: 'HB_TRUSTED_DEVICE',
    MFA_SESSION: 'HB_MFA_SESSION',
    API_VERSION: 'HB_API_VERSION',
    AUTH_USER_ID: 'HB_AUTH_USER_ID',
    CURR_USER: 'HB_CURR_USER',
    SESSION_COMPANY_ID: 'SESSION_COMPANY_ID',
    IS_TEMP_PASS: 'HB_IS_TEMP_PASS',
    COUPON: 'HB_COUPON',
    COUPON_START_DATE: 'HB_COUPON_START_DATE',
    TEMPLATES: 'HB_TEMPLATES',
    OWN_ID_SESSION_TOKEN: 'HB_OWN_ID_SESSION_TOKEN',
    REDIRECT_URL: 'REDIRECT_URL'
};

export const localStorageKeys = {
    HB_USER_DETAILS: 'ngStorage-hb_user_details',
    LAST_ADDED_MEMBER_STORAGE_KEY_PREFIX: 'workspace_lastAddedMemberId_'
} as const;

export const sessionStorageKeys = {
    PARTNER_WELCOME_MODAL_DISPLAY: 'hb_partner_welcome_modal_display',
    HOME_MODAL_DISPLAY: 'home_modal_display',
    COUPON: 'HB_COUPON'
} as const;

export interface IHBUserDetailsStorage {
    email: string;
    first_name: string;
    last_name: string;
    full_name: string;
}

export const REACT_STORAGE_AUTH_KEY = 'HONEYBOOK_REACT_CURR_USER';
